/**
 * Animated Search Placeholder
 * Cycles through search terms every second to create engaging placeholder animation
 */

(function() {
  'use strict';

  // Default search terms to cycle through
  const defaultSearchTerms = [
    'Search Beauty',
    'Search Sulfad',
    'Search Basix',
    'Search Vitamins & Supplements',
    'Search Honst',
    'Search CeraVe',
    'Search Protein & Fitness',
    'Search Bioderma',
    'Search Optimum Nutrition'
  ];

  let animationInstances = new Map();

  function getSearchTerms(searchInput) {
    const attribute = searchInput.getAttribute('data-search-terms');
    if (!attribute) {
      return defaultSearchTerms;
    }

    return attribute
      .split('|')
      .map((term) => term.trim())
      .filter(Boolean);
  }

  function initAnimation(searchInput) {
    // Skip if already initialized for this input
    if (animationInstances.has(searchInput)) {
      return;
    }

    // Mark as initialized
    animationInstances.set(searchInput, null);
    
    const searchTerms = getSearchTerms(searchInput);
    if (!searchTerms.length) {
      return;
    }

    // Store original placeholder
    const originalPlaceholder = searchInput.getAttribute('placeholder') || 'Search';
    
    let currentIndex = 0;
    let intervalId = null;
    let isFocused = false;

    function updatePlaceholder() {
      if (!isFocused && searchInput.value === '') {
        searchInput.setAttribute('placeholder', searchTerms[currentIndex]);
        currentIndex = (currentIndex + 1) % searchTerms.length;
      }
    }

    function startAnimation() {
      if (intervalId) {
        clearInterval(intervalId);
      }
      
      // Set initial placeholder
      updatePlaceholder();
      
      // Update every second (1000ms)
      intervalId = setInterval(updatePlaceholder, 1000);
    }

    function stopAnimation() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function handleFocus() {
      isFocused = true;
      stopAnimation();
      // Reset to original placeholder
      searchInput.setAttribute('placeholder', originalPlaceholder);
    }

    function handleBlur() {
      isFocused = false;
      // Only restart if input is empty
      if (searchInput.value === '') {
        startAnimation();
      }
    }

    // Add event listeners
    searchInput.addEventListener('focus', handleFocus);
    searchInput.addEventListener('blur', handleBlur);

    // Clean up on input (when user types, stop animation)
    searchInput.addEventListener('input', function() {
      if (searchInput.value !== '' && intervalId) {
        stopAnimation();
        if (!isFocused) {
          searchInput.setAttribute('placeholder', originalPlaceholder);
        }
      }
    });

    // Store cleanup function
    const cleanup = function() {
      stopAnimation();
      searchInput.removeEventListener('focus', handleFocus);
      searchInput.removeEventListener('blur', handleBlur);
      searchInput.setAttribute('placeholder', originalPlaceholder);
      animationInstances.delete(searchInput);
    };
    
    animationInstances.set(searchInput, cleanup);

    // Start animation only if input is not focused
    if (document.activeElement !== searchInput) {
      startAnimation();
    }
  }

  function setupInlineSearch() {
    document
      .querySelectorAll('.header__item-search-animations')
      .forEach((searchInput) => initAnimation(searchInput));
  }

  function setupDialogObserver() {
    const searchModal = document.querySelector('#search-modal dialog-component');
    if (!searchModal) return;

    const dialog = searchModal.querySelector('dialog');
    if (!dialog) return;

    // Prevent auto-focus when dialog opens
    const observer = new MutationObserver(function(mutations) {
      if (dialog.hasAttribute('open')) {
        const searchInput = dialog.querySelector('.search-input');
        if (searchInput) {
          // Blur the input immediately to prevent auto-focus
          setTimeout(function() {
            if (document.activeElement === searchInput) {
              searchInput.blur();
            }
            // Initialize animation after blur
            setTimeout(function() {
              initAnimation(searchInput);
            }, 100);
          }, 0);
        }
      }
    });
    
    observer.observe(dialog, {
      attributes: true,
      attributeFilter: ['open']
    });

    // Also listen for dialog:open event as backup
    searchModal.addEventListener('dialog:open', function() {
      const searchInput = searchModal.querySelector('.search-input');
      if (searchInput) {
        // Blur the input
        setTimeout(function() {
          if (document.activeElement === searchInput) {
            searchInput.blur();
          }
          // Initialize animation after blur
          setTimeout(function() {
            initAnimation(searchInput);
          }, 100);
        }, 0);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupInlineSearch();
      setupDialogObserver();
    });
  } else {
    setupInlineSearch();
    setupDialogObserver();
  }

  document.addEventListener('shopify:section:load', setupInlineSearch);
})();
